import React, { useEffect, useState } from "react";
import { Tokens } from "@chainsafe/web3-context/dist/context/tokensReducer";
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/menu";
import { Button } from "@chakra-ui/button";
import { Input } from "@chakra-ui/input";
import VisuallyHidden from "@chakra-ui/visually-hidden";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ChevronDownIcon } from "@chakra-ui/icons";

interface ITokenSelectInput {
  className?: string;
  label: string;
  name: string;
  tokens: Tokens;
  sync?: (value: string) => void;
  options: Array<Object>; // Could be better
  isDisabled: boolean;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  value: string;
}

const TokenSelectInput: React.FC<ITokenSelectInput> = ({
  className,
  label,
  name,
  tokens,
  sync,
  options,
  isDisabled,
  register,
  setValue,
  value,
}: ITokenSelectInput) => {
  const [tokenAddress, setTokenAddress] = React.useState("");
  const handleClick = (selectedValue: string) => {
    setValue(name, selectedValue, { shouldValidate: true }); // Form validation
    setTokenAddress(selectedValue);
  };

  const labelParsed =
    value !== "" && tokens[tokenAddress]
      ? `${label} ${tokens[tokenAddress]?.balance} ${tokens[tokenAddress]?.symbol}`
      : "Please select token";

  const tokenAddressValidator = register(name);

  const [synced, setSynced] = useState("");
  useEffect(() => {
    if (sync && tokenAddress !== synced) {
      setSynced(tokenAddress);
      if (tokenAddress !== "") {
        sync(tokenAddress);
      }
    }
    // eslint-disable-next-line
  }, [tokenAddress]);

  useEffect(() => {
    if (value === "") {
      setSynced("");
      setTokenAddress("");
    }
  }, [value]);

  return (
    <section>
      <Menu gutter={0} matchWidth={true}>
        <MenuButton width="100%" as={Button} rightIcon={<ChevronDownIcon />}>
          {labelParsed}
        </MenuButton>
        <MenuList borderRadius="0px" border="1px solid">
          {options.map((option: any, key) => {
            // TODO: remove this any
            return (
              <MenuItem
                key={key}
                onClick={handleClick.bind(this, option.value)}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu>
      {/* Hidden text field for form validation: */}
      <VisuallyHidden>
        <Input
          name={name}
          value={tokenAddress}
          onChange={tokenAddressValidator.onChange}
          onBlur={tokenAddressValidator.onBlur}
          ref={tokenAddressValidator.ref}
        />
      </VisuallyHidden>
    </section>
  );
};

export default TokenSelectInput;
